import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {TextField, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {MetaTags} from 'react-meta-tags';
///import { LoadingButton } from '@mui/lab';
import AutocompleteTopicz from '../components/AutocompleteTopicz';
import axios from 'axios';
import Cookies from 'js-cookie';
import Tooltip from '@mui/material/Tooltip';
import QuestionBankUpload from './QuestionBankUpload';
import QuestionView from './QuestionView';
import QuestionViewCD from './QuestionViewCD';
//import QuestionEdit from './QuestionEdit';
import DialogAuthorization from '../components/DialogAuthorization';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import Header from "../pages/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
//   var vertical='top',horizontal='center';
  
  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isadminloggedin');
	const childRefNewSave = React.useRef();
	const childRefUpload = React.useRef();
	const childRefAuthorization = React.useRef();
	const childRefQW = React.useRef();
	const childRefCD = React.useRef();
	const childRefEdit = React.useRef();	
	///const authResult = new URLSearchParams(window.location.search);

	const [pageLoading, setPageLoading] = React.useState(true);
	// const [deleteDialogOpt, setDeleteDialogOpt] = React.useState(1);
	// const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
	const [dataLoading, setDataLoading] = React.useState(false);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [page, setPage] = React.useState(0);
	const [rowCount, setRowCount] = React.useState(0);
	const pageSize = 10;

	const [topicList, setTopicList] = React.useState([]);
	const [topicId, setTopicId] = React.useState(0);
	const [topicName, setTopicName] = React.useState("");
	const [batchId, setBatchId] = React.useState(0);

	// const [severityAlert, setSeverityAlert] = React.useState("error");
	// const [showAlert, setShowAlert] = React.useState(false);
	//const [alertMessage, setAlertMessage] = React.useState("");
	const [privileges, setPrivileges] = React.useState("");

	var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
    myPastFromDate.setDate(myPastFromDate.getDate() - 366);

	// function hideAlert(){
	// 	setShowAlert(false);
	// }

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'srno', headerName: 'Sr. No.', width: 40 },
		{ field: 'displayId', headerName: 'Display ID', width: 110},
		{ field: 'batchId', headerName: 'Batch ID', width: 110},
		{ field: 'questionType', headerName: 'Question Type', width: 135, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'topicName', headerName: 'Topic Name', width: 150, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
	    { field: 'keywordNames', headerName: 'Keyword Names', width: 150, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'gradeName', headerName: 'Grade Name', width: 100},
		{ field: 'difficultyName', headerName: 'Difficulty Name', width: 100},		
		{ field: 'tags', headerName: 'Tags', width: 150, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },   
		{ field: 'examType', headerName: 'Exam Type', width: 100},
		{ field: 'language', headerName: 'Language', width: 100},
		{ field: 'country', headerName: 'Country', width: 100},
	    { field: 'modifiedBy', headerName: 'Modified By', width: 150, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'modifiedDateTime', headerName: 'Modified Date/Time', width: 165},
		{ field: 'autoId', headerName: 'Question ID', width: 100},
		    
	  ];
	

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	const handlePageChange = (newPage) => {
		setSelectedRow(0);
		setDataObj(null);
		setPage(newPage);
		setFilter(!filter);
	  };

	React.useEffect(() => {		
		if(userObj.loginId && userObj.token){			
			getApiData();
		}
	}, [userObj]);

	async function getApiData(){
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			let endpoints1 = env.API_URL+"/topic-service/read/list?sortby=topicName";
			const axiosrequest1 = axios.get(endpoints1,axiosHeader);
			await axios.all([axiosrequest1]).then(axios.spread(function(res1) {
			  setPageLoading(false);
			  setTopicList(res1.data.obj.list);
			}));
	}

	React.useEffect(() => {		
		if(userObj.loginId && userObj.token){
			setSelectedRow(0);
			setDataObj({});
			getApiQuestions();
		}
	}, [filter]);

	async function getApiQuestions(){
		///alert(userObj.token);
		if(topicId && topicId>0){
			setPageLoading(true);
			setDataLoading(true);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			
			axios.get(env.API_URL+"/exams/read/question-banks?minRows="+(page*pageSize)+"&maxRows="+pageSize+"&keyword="+keyword+"&topicId="+topicId+"&batchId="+batchId, axiosHeader) 
			   .then(response => {
				///document.write(JSON.stringify(response.data));
				// alert("status >> "+response.status); 
			 	// alert("Just Checking >> "+JSON.stringify(response)); 
				 setPageLoading(false); 
				 setDataLoading(false);
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					childRefAuthorization.current.handleClickOpen();
				}else if(response.data && response.data.responseTxt==="success"){
					if(page===0){
						setRowCount(response.data.obj.rowCount);
					}
					setRows(response.data.obj.list);
					setPrivileges(response.data.obj.privileges);
				}		
			})
			.catch((error) => {
				alert("ERROR: ", error);
			})	
		}	
	}

	function saveData(opt){
		if(opt===1){
			setDataObj({});
			childRefNewSave.current.handleClickOpen();
		}else if(opt===2){
			childRefEdit.current.handleClickOpen();		
		}else if(opt===3){
			childRefUpload.current.handleClickOpen();
		}	
		
	}

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
			///childRef.current.handleClickOpen();
		}
	}

	function search(){
		setPage(0);
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	
	// function updatedList(list,rowCount){
	// 	setSelectedRow(0);
	// 	setDataObj({});
	// 	setRows(list);
	// 	setRowCount(rowCount);
	// }
	function updatedList(){
		search();
	}

	function selectTopic(obj) {
		if(obj && obj.autoId>0){
		  setTopicId(obj.autoId);
		  setTopicName(obj.topicName);
		  search();
		}else{
			setTopicId(0);
		  	setTopicName('');
		}   
	}

	// function numberOnly(event){
	// 	if(event.key === 'Enter'){
	// 		search();
	// 	}else if (!/[0-9]/.test(event.key)) {
	// 		event.preventDefault();
	// 	} 
	// }


	function htmlView(){
		if(dataObj?.questionType?.indexOf("Common Data")>-1){
			childRefCD.current.handleClickOpen();
		}else{
			childRefQW.current.handleClickOpen();
		}
	}

	

	return (
		<div> 
				<MetaTags>
            		<title>Question Banks</title>
          		</MetaTags>
				
				<Header title='Upload Questions' />
				{pageLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

					<Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<div style={{marginRight:5, width: 400, float:'left' }}>
									{(topicList && topicList.length>0)?
                                		<AutocompleteTopicz options={topicList} defaultValue={topicName} handleSelect={selectTopic} variant="outlined" />
                              		:<>Topic List Loading...</>}
										{/* <AutocompleteTopics selectTopic={selectTopic} topicsList={topicList} topicName={topicName} variant="outlined" label="Select Topic" /> */}
									</div>
									{(topicId && topicId>0)?<>
									<FormControl style={{float:'left',width:150,marginRight:60}}>
										<TextField
										id="keywordtxt"
										label="Search"
										defaultValue={keyword}
										sx={{ width: 200 }}
										size="small"
										onChange={event => setKeyword(event.target.value)}
										onKeyPress={(event)=>{onEnter(event)}}
										/>
									</FormControl>
									</>:null}	
									{(topicId && topicId>0)?	
										<Button onClick={() => {search()}} style={{float:'left', marginTop: 3}} size="small" variant="contained" >Search</Button>
									:null}
									
									<div style={{float:'left', marginTop: 5}}>
										{(topicId && topicId>0)?
											<i onClick={()=>{saveData(3)}} title="Upload Object Bank" className="fa fa-upload" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
										:null}
										
										{selectedRow>0?<>
											<i onClick={()=>{htmlView()}} title="HTML View" className="fa fa-info-circle" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />

										</>:null}

									</div>

								</Grid>
							</Grid>
					</Box>

					{(topicId && topicId>0)?						
					<div className="tblReport" style={{height: '78vh', width: '100%' }}>
						<DataGrid
							rows={(rows || [])}
							columns={columns}
							pageSize={pageSize}
							rowsPerPageOptions={[pageSize]}
							rowHeight={40}
							rowCount={rowCount}								
							paginationMode="server"
							onPageChange={handlePageChange}
  							loading={dataLoading}
							disableSelectionOnClick															
							style={{fontSize:12}}	
							onRowClick={itm => selectRow(itm)}	
							///onCellClick={handleOnCellClick}		
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No record found!</span>
								  </Stack>
								)}}	
						/>
					</div>
					:null}

				</Box>
				
			<QuestionBankUpload topicId={topicId} topicName={topicName} ref={childRefUpload} updatedList={updatedList} />
			<QuestionView dataObj={dataObj} ref={childRefQW} />
			<QuestionViewCD dataObj={dataObj} privileges={privileges} updateBtn={false} ref={childRefCD} />

			{/* <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack> */}


				<DialogAuthorization ref={childRefAuthorization} />

		</div>	
	);
  }